module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/devotee/coming-soon/coming-soon.component.css
// module id = ./src/app/devotee/coming-soon/coming-soon.component.css
// module chunks = main